import { Route, Router, Switch, useHistory } from 'react-router-dom';
import React from 'react';
import { EuiText } from '@elastic/eui';
import { ErrorBoundary } from 'components/common';
import { useSelector } from 'react-redux';
import url from 'url';
import { appConfig } from 'config';
import { PAGES } from 'app-constants/pages';
import { RootState } from '../reducers/root';
import { log } from 'console';

const UnAuthorized = () => {
  return <EuiText>Bạn chưa có quyền truy cập!</EuiText>;
};

const NoContent = () => {
  return <EuiText>Updating ...</EuiText>;
};

let lazyImport = {
  [PAGES.DASHBOARD]: React.lazy(() => import('pages/Dashboard')),
  [PAGES.ACCESS_MNT]: React.lazy(() => import('pages/AccessMnt')),
  [PAGES.CUSTOMERS]: React.lazy(() => import('pages/Customers')),
  [PAGES.PARTNERS]: React.lazy(() => import('pages/Partners')),
  [PAGES.ORDER_DEPOSITS]: React.lazy(() => import('pages/Orders/Deposits')),
  [PAGES.BUYING_DETAIL]: React.lazy(() => import('pages/Orders/BuyingDetail')),
  [PAGES.TRANSPORT_VIEW]: React.lazy(
    () => import('pages/Orders/TransportView')
  ),
  [PAGES.CNImport]: React.lazy(() => import('pages/Warehouse/CNImport')),
  [PAGES.CNImportPN]: React.lazy(
    () => import('pages/Warehouse/CNImportPNNext')
  ),
  [PAGES.VNImport]: React.lazy(() => import('pages/Warehouse/VNImport')),
  [PAGES.VNImportNext]: React.lazy(
    () => import('pages/Warehouse/VNImportNext')
  ),
  [PAGES.CNSplit]: React.lazy(() => import('pages/Warehouse/CNSplit')),
  [PAGES.INVENTORY]: React.lazy(() => import('pages/Warehouse/Inventory')),
  [PAGES.CNPacking]: React.lazy(() => import('pages/Warehouse/CNPacking')),
  [PAGES.CNPackingNext]: React.lazy(
    () => import('pages/Warehouse/CNPackingNext')
  ),
  [PAGES.CNDocking]: React.lazy(() => import('pages/Warehouse/CNDocking')),
  [PAGES.CNDockingPN]: React.lazy(() => import('pages/Warehouse/CNDockingPN')),
  [PAGES.ORDER_NEED_TRANSFER_LIST]: React.lazy(
    () => import('pages/Orders/OrderNeedTransferList')
  ),
  [PAGES.ORDER_MANAGE_V2]: React.lazy(
    () => import('pages/Orders/Manage/v2/Manage')
  ),
  [PAGES.WAREHOUSE_RECEIVED_UNKNOWN_LIST]: React.lazy(
    () => import('pages/Warehouse/ReceivedUnknownList')
  ),
  [PAGES.CONFIRM_DELIVERY]: React.lazy(
    () => import('pages/Warehouse/ConfirmDelivery')
  ),
  [PAGES.SHIPMENT_PORT_LIST]: React.lazy(
    () => import('pages/Warehouse/ShipmentPortList')
  ),
  [PAGES.FINANCE_PARTNER_DEBT]: React.lazy(
    () => import('pages/Finance/PartnerDebt')
  ),
  [PAGES.FINANCE_CUSTOMER_REVENUE]: React.lazy(
    () => import('pages/Finance/CustomerRevenue')
  ),
  [PAGES.FINANCE_CONFIGURE_PRICE]: React.lazy(
    () => import('pages/Finance/ConfigurePrice')
  ),
} as any;

if (appConfig.release_type === 'CN_PARTNER') {
  lazyImport = {
    [PAGES.CNPacking]: React.lazy(() => import('pages/Warehouse/CNPacking')),
    [PAGES.CNDocking]: React.lazy(() => import('pages/Warehouse/CNDocking')),
    [PAGES.INVENTORY]: React.lazy(() => import('pages/Warehouse/Inventory')),
    [PAGES.CNImportPN]: React.lazy(() => import('pages/Warehouse/CNImportPN')),
  };
}

const Routes = (): JSX.Element => {
  const mainRoutes = (pageList = []): JSX.Element => {
    const home = lazyImport[pageList[0].PAGE_COMPONENT];
    return (
      <ErrorBoundary>
        <Switch>
          <Route exact path="/" component={home} />
          {pageList.map((page) => {
            !lazyImport[page.PAGE_COMPONENT] &&
              console.log(
                'render_null',
                page.PAGE_COMPONENT,
                PAGES.ORDER_MANAGE_V2
              );
            return (
              <Route
                key={url.resolve('/', page.PAGE_PATH)}
                path={url.parse(url.resolve('/', page.PAGE_PATH)).pathname}
                component={
                  lazyImport[page.PAGE_COMPONENT]
                    ? lazyImport[page.PAGE_COMPONENT]
                    : NoContent
                }
              />
            );
          })}
        </Switch>
      </ErrorBoundary>
    );
  };

  const renderSwitch = (pageList = []) => {
    return (
      <ErrorBoundary>
        <Switch>
          {!pageList.length ? (
            <Route exact path="/" component={UnAuthorized} />
          ) : (
            mainRoutes(pageList)
          )}
        </Switch>
      </ErrorBoundary>
    );
  };

  const history = useHistory();
  const pageList = useSelector((state: RootState) => state.auth.pageList);
  const routes = React.useMemo(
    () => <Router history={history}>{renderSwitch(pageList)}</Router>,
    [pageList.length]
  );

  // Log danh sách routes
  // console.table(
  //   pageList.map((page) => ({
  //     PATH: page.PAGE_PATH,
  //     COMPONENT: page.PAGE_COMPONENT,
  //     ĐÃ_CÓ_TRONG_LAZY_IMPORT: !!lazyImport[page.PAGE_COMPONENT],
  //   }))
  // );

  return routes;
};

export default Routes;
